'use client';
import { createContext, PropsWithChildren, useState } from 'react';

import { HeaderProps } from '@/types/common';
import { not } from '@/utils/common';

export const HeaderRightSectionContext = createContext<
  | ({
      isOpenBurgerContent: boolean;
      setIsOpenBurgerContent(isOpen: boolean): void;
      toggleIsOpenBurgerContent(): void;
    } & HeaderProps)
  | null
>(null);

export function HeaderRightSectionProvider({ children }: PropsWithChildren<HeaderProps>) {
  const [isOpenBurgerContent, setIsOpenBurgerContent] = useState(false);

  const toggleIsOpenBurgerContent = () => setIsOpenBurgerContent(not);

  return (
    <HeaderRightSectionContext.Provider
      value={{
        isOpenBurgerContent,
        setIsOpenBurgerContent,
        toggleIsOpenBurgerContent,
      }}
    >
      {children}
    </HeaderRightSectionContext.Provider>
  );
}
